// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N1iw","newExpiryDate":"styles_newExpiryDate__32byy","footer":"styles_footer__8CDn0"};